import React, { useState, useEffect } from 'react';
import {
  Grid,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
} from '@mui/material';
import { SettingsApplications as WidgetIcon } from '@mui/icons-material';
import StatCard from './StatCard';

const STORAGE_KEY = 'visibleStatsTitles';

const StatsGrid = ({ stats }) => {
  const [visibleStats, setVisibleStats] = useState(stats);
  const [showSelector, setShowSelector] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const savedTitles = JSON.parse(saved);
      const filtered = stats.filter(stat => savedTitles.includes(stat.title));
      setVisibleStats(filtered.length ? filtered : stats);
    }
  }, [stats]);

  useEffect(() => {
    const titles = visibleStats.map(stat => stat.title);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(titles));
  }, [visibleStats]);

  const handleHide = (indexToRemove) => {
    setVisibleStats(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleReset = () => {
    setVisibleStats(stats);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stats.map(stat => stat.title)));
  };

  const handleToggleStat = (title) => {
    setVisibleStats(prev => {
      const exists = prev.find(stat => stat.title === title);
      if (exists) {
        return prev.filter(stat => stat.title !== title);
      } else {
        const statToAdd = stats.find(stat => stat.title === title);
        return [...prev, statToAdd];
      }
    });
  };

  const cardCount = visibleStats.length;
  const md = cardCount >= 4 ? 3 : cardCount === 3 ? 4 : cardCount === 2 ? 6 : 12;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 2 }}>
        {cardCount < stats.length && (
          <Button onClick={handleReset} variant="outlined" size="small" sx={{ mr: 1 }}>
            Reset Cards
          </Button>
        )}
        <IconButton onClick={() => setShowSelector(prev => !prev)}>
          <WidgetIcon />
        </IconButton>
      </Box>

      {showSelector && (
        <Paper
          elevation={1}
          sx={{
            mb: 2,
            p: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.7)', // transparent look
            backdropFilter: 'blur(5px)',
            borderRadius: 2,
          }}
        >
          {stats.map(stat => (
            <FormControlLabel
              key={stat.title}
              control={
                <Checkbox
                  checked={!!visibleStats.find(v => v.title === stat.title)}
                  onChange={() => handleToggleStat(stat.title)}
                />
              }
              label={stat.title}
              sx={{ display: 'block' }}
            />
          ))}
        </Paper>
      )}

      <Grid container spacing={3}>
        {visibleStats.map((stat, index) => (
          <Grid item xs={12} md={md} key={index}>
            <StatCard {...stat} onHide={() => handleHide(index)} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StatsGrid;
